import React, { useCallback, useEffect, useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import * as S from './styles';

export default function Dropzone({ setImage, disabled }) {
  const { t } = useTranslation();
  const [fileName, setFileName] = useState();
  const onDrop = useCallback(
    acceptedFiles => {
      acceptedFiles.forEach(file => {
        const reader = new FileReader();

        reader.onabort = () => {};
        reader.onerror = () => {};
        reader.onload = () => {
          // Do whatever you want with the file contents
          setImage(file);
          setFileName(file.path);
        };
        reader.readAsArrayBuffer(file);
      });
    },
    [setImage]
  );
  const { getRootProps, getInputProps, rejectedFiles } = useDropzone({
    onDrop,
    accept: 'image/jpeg, image/png, image/jpg',
    disabled,
  });

  useEffect(() => {
    if (rejectedFiles.length > 0) toast.error(t('fileTypeNotPermitted'));
  }, [rejectedFiles, t]);

  return (
    <S.DropzoneContainer {...getRootProps()}>
      <input id="image" name="image" {...getInputProps()} accept="image/*" />
      <S.Message1>{fileName || t('dropzoneMessage1')}</S.Message1>
      {!fileName && <S.Message2>{t('dropzoneMessage2')}</S.Message2>}
    </S.DropzoneContainer>
  );
}

Dropzone.propTypes = {
  setImage: PropTypes.func,
  disabled: PropTypes.bool,
};

Dropzone.defaultProps = {
  setImage: () => {},
  disabled: false,
};
